<template>
  <div class="payment-cancel">
    <div class="cancel-container">
      <h2>Payment Cancelled</h2>

      <div class="cancel-message">
        <p>You have cancelled the payment process.</p>
        <p>You ll be redirect to your Rapport employee page.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentCancel',
  data() {
    return {
      countValue: 5
    }
  },
  created() {
    // Retrieve order details from local storage or Vuex
    this.goToRapportsSalarie()
  },
  methods: {
    goToRapportsSalarie() {
      setTimeout(() => {
        if (this.countValue > 0) {
          this.countValue -= 1
          if (this.countValue === 0) {
            window.location.href = process.env.VUE_APP_JABALI_WEB_BASE_URL + '/agents/rapportssalarie';
          } else {
            this.goToRapportsSalarie()
          }
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
.payment-cancel {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;
}

.cancel-container {
  background-color: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.order-summary {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 5px;
}
</style>